import { useState, useEffect } from "react";
import axios from "../../api/axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import Select from "react-select";

export default function CreateUser() {
    const { id } = useParams();
    const navigate = useNavigate();
    const isEdit = Boolean(id);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        role: ''
    });

    const [roles, setRoles] = useState([]);

    useEffect(() => {
        axios.get("/roles").then(res => {
            const roleOption = res.data?.map((item) => {
                return { value: item.id, label: item.name };
            });
            setRoles(roleOption)
        });
        if (isEdit) {
            axios.get(`/users/${id}`).then(res => {
                const { name, email, role } = res.data;
                setFormData({ name, email, password: '', role });
            });
        }
    }, [id, isEdit]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEdit) {
                await axios.put(`/users/${id}`, formData);
                toast.success('User updated successfully')
            } else {
                await axios.post("/users/register", formData);
                toast.success('User created successfully')
            }
            navigate("/user-list");
        } catch (error) {
            console.error(error);
            toast.error('Failed to submit')
        }
    };

    return (
        <div className="mx-auto p-4 bg-white rounded-xl shadow">
            <h2 className="text-xl font-semibold mb-4">{id ? "Edit User" : "Create New User"}</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="block mb-1 font-medium">Name</label>
                        <input
                            type="text"
                            name="name"
                            placeholder="Enter name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-1"
                            required
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Email</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-1"

                        />
                    </div>
                    {!isEdit && (
                        <div>
                            <label className="block mb-1 font-medium">Password</label>
                            <input
                                type="password"
                                name="password"
                                placeholder="Enter password"
                                value={formData.password}
                                onChange={handleChange}
                                className="w-full border rounded px-3 py-1"

                            />
                        </div>
                    )}

                    <div>
                        <label className="block mb-1 font-medium">Role</label>
                        <Select
                            name="parent_id"
                            onChange={e => setFormData(f => ({ ...formData, role: e.value }))}
                            value={roles.filter((v) => v.value === formData.role)}
                            options={roles}
                            placeholder="Select Role"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>

                </div>
                <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                    {isEdit ? 'Update User' : 'Create User'}
                </button>
            </form>
        </div>
    );
}
